module.exports = __webpack_public_path__ + "img/xinwen2.9ef2750d.jpg";